import React from 'react';

interface AddPersonOptionProps {
  text: string;
  handleClick?: (() => void) | null;
  icon?: string;
}

export function AddPersonOption({ 
  text, 
  handleClick = null,
  icon = 'person_add'
}: AddPersonOptionProps) {
  const classes = [ 'person-select-option', 'clickable' ];

  return (
    <div className={classes.join(' ')} onClick={handleClick}>
      <div className="person-select-icon-container">
        <span className="material-symbols-outlined">
          {icon}
        </span>
      </div>
      <div className="person-select-text-container">
        <span className="person-select-text">{text}</span>
        <span className="person-select-subtext">
        </span>
      </div>
    </div>
  );
}
